import { MRT_ColumnDef } from "material-react-table"
import { useMemo } from "react"
import { IDataSolicitudFallido, IDataSolicitudSupercion } from "../interfaces/erp/supervision/supervision.interface"
import { EstadoComponente } from "../components/ui";
import { calcColorStatusGeneral, cellEstadoVentaSupervisor, cellIngresoBenificio, cellNotFilter, emptyCellObject, formatDateWithTimeAMPM } from "../utils";
import InfoUser from "../components/ui/InfoUser/InfoUser";
import { SolicitudTutorDescuentoEstadoSolicitudEnum } from "../interfaces";

interface useTableColumnsSolicitudIngresoProspectoProps {
  estado_solicitud: SolicitudTutorDescuentoEstadoSolicitudEnum
}
export const useTableColumnsSolicitudIngresoProspecto = ({
  estado_solicitud
}: useTableColumnsSolicitudIngresoProspectoProps) => {


  const columnBase = useMemo<MRT_ColumnDef<IDataSolicitudSupercion>[]>(() => [
    {
      accessorKey: 'identificacion',
      header: 'Identificación Cliente',
      Cell: ({ row }) => (
        row.original.prospecto_data?.identificacion
      ),
      size: 100
    },
    {
      id: 'razon_social',
      accessorKey: 'cliente_razon_social',
      header: 'Nombre Cliente',
      size: 200,
      Cell: ({ row }) => (
        row.original.prospecto_data != null ? row.original.prospecto_data.razon_social : '—'
      ),
    },
    {
      accessorKey: 'beneficio',
      header: 'Beneficio Solicitado',
      size: 250,
      Cell: ({ row }) => (
        <EstadoComponente
          backgroundColor={calcColorStatusGeneral(row.original.estado_solicitud)}
          texto={cellIngresoBenificio(row.original.prospecto_data)}
        />
      ),
      enableColumnFilter: false,
    },
    {
      accessorKey: 'observaciones_solicitud',
      header: 'Observacion Solicitud',
      size: 300,
      enableColumnFilter: false,
      Cell: ({ row }) => (
        row.original.observaciones?.observacion_solicitud ?? '—'
      )
    },

    ...(estado_solicitud != SolicitudTutorDescuentoEstadoSolicitudEnum.EN_ESPERA ? [{
      accessorKey: 'observacion_supervisor',
      header: 'Observación supervisor',
      size: 150,
      Cell: ({ row }: any) => emptyCellObject(row.original.observaciones, 'observacion_supervisor')
    }] : []),
    {
      ...cellNotFilter,
      accessorKey: 'fecha',
      header: 'Fecha de registro',
      enableColumnFilter: false,
      enableSorting: false,
      size: 200,
      Cell: ({ row }) => (
        formatDateWithTimeAMPM(cellEstadoVentaSupervisor(row.original).fecha_registro)
      ),
    },

    {
      ...cellNotFilter,
      accessorKey: 'estado',
      header: 'Estado Solicitud',
      size: 150,
      enableColumnFilter: false,
      enableSorting: false,
      Cell: ({ row }) => (
        row.original.estado != null ?
          <EstadoComponente
            backgroundColor={calcColorStatusGeneral(row.original.estado_solicitud)}
            texto={row.original.estado_solicitud || ''} /> : null
      ),
    },
    /* {
      ...cellNotFilter,
      accessorKey: 'estado_flujo',
      header: 'Estado Venta',
      size: 200,
      Cell: ({ row }) => (
        <EstadoComponente backgroundColor={'blue'} texto={cellEstadoVentaSupervisor(row.original).modulo || ''} />
      )
    }, */
    {
      ...cellNotFilter,
      accessorKey: 'canal_venta_create',
      header: 'canal venta',
      size: 200,
    },
    {
      ...cellNotFilter,
      accessorKey: 'prospecto_data.segmentacion',
      header: 'Segmentacion',
      size: 200,
    },
    {
      ...cellNotFilter,
      accessorKey: 'prospecto_data.puntaje_score',
      header: 'score',
      size: 200,
    },
    {
      ...cellNotFilter,
      accessorKey: 'prospecto_data.puntaje_score_empresa',
      header: 'score empresa',
      size: 200,
    },
    {
      ...cellNotFilter,
      accessorKey: 'prospecto_data.puntaje_score_sobreendeudamiento',
      header: 'score sobreendeudamiento',
      size: 200,
    },
    {
      accessorKey: 'user_create',
      header: 'Usuario Solicito',
      size: 200,
      Cell: ({ row }) => {
        return <InfoUser user={row?.original.user_create!} />
      },
    },
    {
      accessorKey: 'user_aprueba',
      header: 'Usuario Aprobación',
      size: 200,
      Cell: ({ row }) => {
        return <InfoUser user={row?.original.user_aprueba!} />
      },
    },
  ], []);

  const columnBaseLiberacionProspecto = useMemo<MRT_ColumnDef<IDataSolicitudFallido>[]>(() => [
    {
      accessorKey: 'identificacion',
      header: 'Identificación Cliente',
      size: 200,
      Cell: ({ row }) => (
        row.original.prospecto_data != null ? row.original.prospecto_data.identificacion : '—'
      ),
    },
    {
      accessorKey: 'razon_social',
      header: 'Nombre Cliente',
      size: 200,
      Cell: ({ row }) => (
        row.original.prospecto_data != null ? row.original.prospecto_data.razon_social : '—'
      ),
    },
    {
      ...cellNotFilter,
      accessorKey: 'fecha_creacion',
      header: 'Fecha de registro',
      size: 200,
      Cell: ({ row }) => (
        formatDateWithTimeAMPM(row.original.prospecto_data.fecha_creacion)
      ),
    },
    {
      ...cellNotFilter,
      accessorKey: 'estado',
      header: 'Estado Solicitud',
      size: 150,
      Cell: ({ row }) => (
        row.original.estado != null ?
          <EstadoComponente
            backgroundColor={calcColorStatusGeneral(row.original.estado_solicitud)}
            texto={row.original.estado_solicitud || ''} /> : null
      ),
    },
    {
      ...cellNotFilter,
      accessorKey: 'canal_venta_create',
      header: 'canal venta',
      size: 200,
    },
    {
      ...cellNotFilter,
      accessorKey: 'prospecto_data.segmentacion',
      header: 'Segmentacion',
      size: 200,
    },
    {
      ...cellNotFilter,
      accessorKey: 'prospecto_data.puntaje_score',
      header: 'score',
      size: 200,
    },
    {
      ...cellNotFilter,
      accessorKey: 'prospecto_data.puntaje_score_empresa',
      header: 'score empresa',
      size: 200,
    },
    {
      ...cellNotFilter,
      accessorKey: 'prospecto_data.puntaje_score_sobreendeudamiento',
      header: 'score sobreendeudamiento',
      size: 200,
    },
    {
      accessorKey: 'user_create',
      header: 'Usuario Solicito',
      size: 200,
      Cell: ({ row }) => {
        return <InfoUser user={row.original.user_create} />
      },
    },
  ], []);

  return {
    columnBase,
    columnBaseLiberacionProspecto
  }
}